import { render, staticRenderFns } from "./orderSamples_form.vue?vue&type=template&id=173587e2&scoped=true&"
import script from "./orderSamples_form.vue?vue&type=script&lang=js&"
export * from "./orderSamples_form.vue?vue&type=script&lang=js&"
import style0 from "./orderSamples_form.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderSamples_form.vue?vue&type=style&index=1&id=173587e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173587e2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173587e2')) {
      api.createRecord('173587e2', component.options)
    } else {
      api.reload('173587e2', component.options)
    }
    module.hot.accept("./orderSamples_form.vue?vue&type=template&id=173587e2&scoped=true&", function () {
      api.rerender('173587e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/orderSamples_form.vue"
export default component.exports